import type { App } from 'vue';
import * as Sentry from '@sentry/vue';

import { router } from './providers';

export function sentryInit(app: App) {
  if (import.meta.env.MODE === 'development' && import.meta.env.VITE_APP_SENTRY_LOGGER !== 'true') return;

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_APP_ENDPOINT_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
          hooks: ['activate', 'create', 'unmount', 'mount', 'update'],
        },
      }),
    ],
    // tracePropagationTargets: ['localhost', 'https://mobile-dev.optimabusiness.kg'],
    tracesSampleRate: import.meta.env.MODE === 'stage' ? 1.0 : 0.1, // 10% транзакций для анализа производительности
    replaysSessionSampleRate: import.meta.env.MODE === 'stage' ? 0.1 : 0.01, // 1% сессий без ошибок для UX анализа (почти выключено)
    replaysOnErrorSampleRate: 1.0,
    debug: import.meta.env.VITE_APP_SENTRY_LOGGER === 'true',
    release: import.meta.env.VITE_APP_VERSION,
    environment: import.meta.env.MODE,
    // Фильтрация событий перед отправкой
    beforeSend(event, hint) {
      // @ts-ignore
      const message = hint?.originalException?.message || event?.message || '';
      const filteredMessages = [
        'Channel is closed',
        'Non-Error promise rejection captured with value: Timeout',
        '[Network] Not Allowed',
        'Failed to fetch (',
        'Invalid navigation guard',
        'Unable to preload',
        'NetworkError',
        'Failed to fetch dynamically imported module',
        'Large Render Blocking Asset',
        'Uncompressed Asset',
        'AbortError',
        'Importing a module script failed',
        'Не удалось найти уведомление',
        'AbortError: The operation was aborted.',
        'error loading dynamically imported module',
      ];

      if (filteredMessages.some((msg) => message.includes(msg))) return null;

      return event;
    },
  });
}
